var $=jQuery;
jQuery(document).ready(function ($) {

   // add to cart 
    $(document).on('submit', '.js-card-add-to-cart', function(e) {
      e.preventDefault();
      var $form = $(this);
      var formData = new FormData(this);

      var id = formData.get('id');
      
      if (!id) {
        return;
      }

      var $btn = $form.find('[type="submit"]');
      $btn.prop('disabled', true).addClass('loading');

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(item) {
            var url = new URL(window.location.href);
              url.searchParams.set("open_cart_n", "1");
              window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
        },
        complete: function() {
          // Re-enable button
          $btn.prop('disabled', false).removeClass('loading');
        }
      });
    });
    // add to cart 
    

  //  var $container = $('.variant-featured_image-custom');
  //   var itemCount = $container.find('.custom-variants-image-block.standard-option').length;

  //   if (itemCount > 3) {
  //     $container.flickity({
  //       cellAlign: 'left',
  //       contain: true,
  //       pageDots: false,
  //       wrapAround: true,
  //       prevNextButtons: true,
  //       draggable: true,
  //       freeScroll: true
  //     });
  //   } else {
  //     $container.addClass('no-slider-custom');
  //   }


  
  //  var urlParams = new URLSearchParams(window.location.search);
  // if (!urlParams.has('variant')) {
  //   if ($('.page-width').hasClass('b2b')) {
  //     var firstB2B = $('input.b2b-option[type=radio]').not(':disabled').first();
  //     if (firstB2B.length && !firstB2B.prop('checked')) {
  //       firstB2B.prop('checked', true).trigger('change')
       
  //       var label = $('label[for="' + firstB2B.attr('id') + '"]');
  //       label.trigger('click');
  //     }
  //   }
  // }
      // if ($('.page-width-custom').hasClass('b2b')) {
      //     var firstB2B = $('input.b2b-option[type=radio]').not(':disabled').first();
      //   if (firstB2B.length && !firstB2B.prop('checked')) {
      //       var label = $('label[for="' + firstB2B.attr('id') + '"]');
      //       if (label.length) {
      //           label.trigger('click');
      //       } else {
      //           firstB2B.prop('checked', true).trigger('change');
      //       }
      //   }
      // }
      if ($('.page-width-custom').hasClass('b2b')) {
      var $select = $('select'); 
      if ($select.length) {
        var $firstB2B = $select.find('option.b2b-option:not(:disabled)').first();
        var $firstB2B = $select.find('option.b2b-option:not(:disabled)').first();
          if ($firstB2B.length && !$firstB2B.is(':selected')) {
            $select.val($firstB2B.val());
        
            $select[0].dispatchEvent(new Event('change', { bubbles: true }));
          }
      }
    } else {
      var $select = $('select'); 
      if ($select.length) {
        var $firstStandard = $select.find('option.standard-option:not(:disabled)').first();
        if ($firstStandard.length && !$firstStandard.is(':selected')) {
          $select.val($firstStandard.val()).trigger('change');
        }
      }
    }



  
   $(".product-single__thumbnails").flickity({
      pageDots: false,
      freeScroll: false,
      wrapAround: false,
      // prevNextButtons: true,
      // autoPlay: false,
      // groupCells: false,
      cellAlign: 'left',
     asNavFor: '.product-single__gallery'
    });
    //initFlickityMobile
    function initFlickityMobile() {
        var $lists = $(".nt_bestseller_sec .contains-card,.slider-related .grid");
        if ($(window).width() < 950) {
            $lists.each(function() {
                if (!$(this).data('flickity')) {
                    $(this).flickity({
                        pageDots: true,
                        freeScroll: false,
                        wrapAround: true,
                        prevNextButtons: false,
                        autoPlay: 5000,
                        groupCells: false,
                        cellAlign: 'left'
                    });
                }
            });
        } else {
            $lists.each(function() {
                if ($(this).data('flickity')) {
                    $(this).flickity('destroy');
                }
            });
        }
    }
    $(document).ready(initFlickityMobile);
    $(window).on('resize', initFlickityMobile);
/** CUSTOM ***/
  $('.tag-item.kategorie').on('click', function() {
    var selectedTag = $(this).data('tag').toLowerCase().replace(/\s+/g, '-');

    $('.arrow_gallery').each(function() {
      var galleryTag = $(this).data('tag');
      if (galleryTag === selectedTag) {
        $(this).show();
      } else {
        $(this).hide();
      }
    });
  });
   $('.sort-option').on('click', function() {
    var sortType = $(this).data('sort'); 

    var $container = $('.arrow_gallery').parent(); 
    var $items = $('.arrow_gallery').detach(); 

    $items.sort(function(a, b) {
      var tagA = $(a).data('tag').toLowerCase();
      var tagB = $(b).data('tag').toLowerCase();

      if (sortType === 'a-z') {
        return tagA.localeCompare(tagB);
      } else {
        return tagB.localeCompare(tagA);
      }
    });

    $container.append($items);
  });

  var swiper; 

$(document).on('click', '.blog-post-image', function () {
    var $this = $(this);
    var $parentGroup = $this.closest('.group_handle');

    // Collect handles for all images in this group
    var handles = [];
    $parentGroup.find('.blog-post-image').each(function () {
        handles.push($(this).data('handle'));
    });

    var clickedHandle = $this.data('handle');
    var clickedIndex = $parentGroup.find('.blog-post-image').index($this);

    $('#post-popup').fadeIn();

    // Destroy old swiper safely
    if (swiper) {
        if (typeof swiper.destroy === 'function') {
            swiper.destroy(true, true);
        }
        swiper = null;
    }
    $('.popup-swiper .swiper-wrapper').empty();

    // Append new slides with data-handle
    handles.forEach(function (h, idx) {
        $('.popup-swiper .swiper-wrapper').append(
            '<div class="swiper-slide swiper-slide-custom" data-handle="' + h + '" data-index="' + idx + '">' +
              '<div class="popup-content-inner" data-handle="' + h + '"></div>' +
            '</div>'
        );
    });

    // Init new swiper
    swiper = new Swiper('.popup-swiper', {
        loop: false,
        navigation: {
            nextEl: '#post-popup .swiper-button-next',
            prevEl: '#post-popup .swiper-button-prev',
        },
        allowTouchMove: false,
        on: {
            init: function () {
                this.update();

                // Jump to the clicked slide
                if (typeof this.slideTo === 'function' && clickedIndex >= 0) {
                    this.slideTo(clickedIndex, 0);
                }

                // Load content for current slide
                var handleNow = $('.popup-swiper .swiper-slide').eq(clickedIndex).data('handle');
                if (handleNow) loadPostContent(handleNow, clickedIndex);
            },
            slideChange: function () {
                var index = this.realIndex;
                // Always get handle from the actual slide to avoid mismatch
                var handleNow = $('.popup-swiper .swiper-slide').eq(index).data('handle');
                if (handleNow) loadPostContent(handleNow, index);
            }
        }
    });

    // 🚨 REMOVE duplicate slideTo here (already handled in init)
    // if (swiper && typeof swiper.slideTo === 'function') {
    //     swiper.slideTo(clickedIndex, 0);
    // }

    console.log('Clicked:', clickedHandle, 'Index:', clickedIndex);
});


// Close popup
$('#close-popup').click(function () {
    $('#post-popup').fadeOut();
});

// Close popup if clicked outside
$(window).click(function (event) {
    if ($(event.target).is('#post-popup')) {
        $('#post-popup').fadeOut();
    }
});

function loadPostContent(handle, index) {
    var slide = $('.popup-swiper .swiper-slide')
        .eq(index)
        .find('.popup-content-inner');

    if (slide.data('loaded')) return;

  var url = '/blogs/' + handle + '?view=ajax';
  console.log(url);
    $.ajax({
        url: url,
        method: 'GET',
        success: function (response) {
            var postContent = $(response)
                .find('.load-data-blog-content')
                .html();
            slide.html(postContent || 'No Content Available');
            slide.data('loaded', true);
        }
    });
}

  
  /** CUSTOM ***/
  $('.collapsible-content .accordion__content a').attr('download', 'download');
  $('.footer-block.has-dropdown .footer-block__heading,.dropbtn').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  
  $('.right-item .readmore').click(function (e) { 
        e.preventDefault();
        $(this).hide();
        $('.right-item .text-block').addClass('showing');
  });
  const content = $('.content-single');
    const readMore = $('.readmore');

    if (content.outerHeight() > 288) {
        content.addClass('limit');
        readMore.show();
    } else {
        readMore.hide();
    }

    readMore.click(function (e) {
        e.preventDefault();
        content.removeClass('limit');
        $(this).hide();
    });
});
//Swipper slider
$(document).ready(function(){
  ///// Tab Faq
  $(document).on('click','.acctab_title', function(e){
     if($(window).width() >= 768){
        $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }else{
       $('.acctab_title').removeClass('active-accor');
        $(this).addClass('active-accor');
        $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
        // $('.acc_tab-inner .acc-tab-content .tabs-content').removeClass('activemain-tab').hide();
        $('.acc_tab-inner .acc-tab-content').addClass('tab-content-show').show();
        $($(this).attr('data-act-title')).addClass('activemain-tab').show();
     }
  });
  $(document).on('click','.acc_tab-inner .acc-tab-content .back__arrow', function(e){
      $('.acc_tab-inner .acc-tab-content').removeClass('tab-content-show').show();
  });
  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
  });
  ///// Tab Faq
});

document.addEventListener("DOMContentLoaded", () => {
    const counterSection = document.querySelector(".st-counter");
    if (!counterSection) return; 
    
    const counters = counterSection.querySelectorAll(".multicolumn-card__info h3 strong");

    let hasCounted = false;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !hasCounted) {
                startCounter();
                hasCounted = true;
                observer.disconnect();
            }
        });
    }, { threshold: 0.5 });

    observer.observe(counterSection);

    function startCounter() {
        counters.forEach(counter => {
            const target = parseInt(counter.textContent.replace(/\D/g, ""), 10);
            let count = 0;
            const increment = target / 100;

            const updateCount = () => {
                count += increment;
                if (count < target) {
                    counter.textContent = Math.ceil(count);
                    requestAnimationFrame(updateCount);
                } else {
                    counter.textContent = target;
                }
            };

            updateCount();
        });
    }
});
 //load more product
   document.addEventListener('DOMContentLoaded', function() {
    const loadMoreButton = document.querySelector('[data-pagination-btn]');
    const productGrid = document.getElementById('product-grid');
    
    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function(e) {
            e.preventDefault();
            const nextUrl = loadMoreButton.getAttribute('href');
            
            loadMoreButton.textContent = "Laden...";
            loadMoreButton.setAttribute('disabled', 'true');
            
            fetch(nextUrl)
                .then(response => response.text())
                .then(data => {
                    const tempDiv = document.createElement('div');
                    tempDiv.innerHTML = data;
                    
                    const newProducts = tempDiv.querySelector('#product-grid').innerHTML;
                    
                    productGrid.innerHTML += newProducts;
                    
                    // var sliderProducts = document.querySelectorAll('.has-slider-wrapper');

                    // sliderProducts.forEach(function(slider) {
                    //     new Flickity(slider, {
                    //         pageDots: false,
                    //         freeScroll: false,
                    //         wrapAround: true,
                    //         prevNextButtons: true,
                    //         autoPlay: false,
                    //         groupCells: false,
                    //         cellAlign: 'center',
                    //     });
                    // });
                    
                    const newButton = tempDiv.querySelector('[data-pagination-btn]');
                    if (newButton) {
                        loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
                        loadMoreButton.textContent = "MEHR ANZEIGEN";
                        loadMoreButton.removeAttribute('disabled');
                    } else {
                        loadMoreButton.textContent = "Keine Produkte mehr";
                        loadMoreButton.style.display = "none";
                    }
                })
                .catch(error => {
                    console.error('Error loading more products:', error);
                    loadMoreButton.textContent = "Try again";
                    loadMoreButton.removeAttribute('disabled');
                });
        });
    }
  });
class PriceRange1 extends HTMLElement {
  connectedCallback() {
    this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child");
    this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child");
    this.textInputLowerBound = this.querySelector(".price-range__input:first-child input");
    this.textInputHigherBound = this.querySelector(".price-range__input:last-child input");

    // Event listeners for text input focus and change
    this.textInputLowerBound.addEventListener("focus", () => this.textInputLowerBound.select());
    this.textInputHigherBound.addEventListener("focus", () => this.textInputHigherBound.select());

    this.textInputLowerBound.addEventListener("change", (event) => {
      const newValue = Math.max(Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1), event.target.min);
      event.target.value = newValue;
      this.rangeLowerBound.value = newValue;
      this.updateRangeStyles();
    });

    this.textInputHigherBound.addEventListener("change", (event) => {
      const newValue = Math.min(Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1), event.target.max);
      event.target.value = newValue;
      this.rangeHigherBound.value = newValue;
      this.updateRangeStyles();
    });

    // Event listeners for range slider change and input
    this.rangeLowerBound.addEventListener("change", (event) => {
      this.textInputLowerBound.value = event.target.value;
      this.textInputLowerBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeHigherBound.addEventListener("change", (event) => {
      this.textInputHigherBound.value = event.target.value;
      this.textInputHigherBound.dispatchEvent(new Event("change", { bubbles: true }));
    });

    this.rangeLowerBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.min(parseInt(event.target.value), parseInt(this.textInputHigherBound.value || event.target.max) - 1);
      this.textInputLowerBound.value = event.target.value;
      this.updateRangeStyles();
    });

    this.rangeHigherBound.addEventListener("input", (event) => {
      this.dispatchEvent(new CustomEvent("collection:abort-loading", { bubbles: true }));
      event.target.value = Math.max(parseInt(event.target.value), parseInt(this.textInputLowerBound.value || event.target.min) + 1);
      this.textInputHigherBound.value = event.target.value;
      this.updateRangeStyles();
    });
  }

  updateRangeStyles() {
    this.rangeLowerBound.parentElement.style.setProperty("--range-min", `${(parseInt(this.rangeLowerBound.value) / parseInt(this.rangeLowerBound.max)) * 100}%`);
    this.rangeHigherBound.parentElement.style.setProperty("--range-max", `${(parseInt(this.rangeHigherBound.value) / parseInt(this.rangeHigherBound.max)) * 100}%`);
  }
}

